import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'hi', name: 'Hindi' },
  { code: 'gu', name: 'Gujarati' },
  { code: 'mr', name: 'Marathi' },
  { code: 'bn', name: 'Bengali' },
];

export default function LanguageSelector({ currentLanguage, onLanguageChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredLanguages = languages.filter(lang =>
    lang.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const activeLanguage = languages.find(l => l.code === currentLanguage) || languages[0];

  return (
    <div className="custom-lang-selector" ref={dropdownRef}>
      <button
        className={`lang-toggle ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <FontAwesomeIcon icon={faLanguage} className="lang-icon" />
        <span className="current-lang-name">{activeLanguage.name}</span>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="chevron-icon" />
      </button>

      {isOpen && (
        <div className="lang-dropdown">
          {/* <div className="lang-search-wrapper">
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
            <input 
              type="text" 
              placeholder="Search..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div> */}
          <div className="lang-list">
            {filteredLanguages.map((lang) => (
              <div
                key={lang.code}
                className={`lang-item ${currentLanguage === lang.code ? 'selected' : ''}`}
                onClick={() => {
                  onLanguageChange(lang.code);
                  setIsOpen(false);
                }}
              >
                <span className="lang-text">{lang.name}</span>
                {currentLanguage === lang.code && <span className="selection-dot"></span>}
              </div>
            ))}
            {filteredLanguages.length === 0 && (
              <div className="no-results">No languages found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
